@if (currentLanguage | async; as currentLanguage) {
  <button mat-icon-button [matMenuTriggerFor]="languageMenu">
    <span class="fi fi-{{ currentLanguage.flagIso2 }}"></span>
  </button>
}

<mat-menu #languageMenu="matMenu" xPosition="before">
  @for (lang of supportedLanguages; track lang) {
    <button mat-menu-item (click)="onLanguageSelect(lang)">
      <span class="fi fi-{{ lang.flagIso2 }}"></span>
      {{ lang.name | translate }}
    </button>
  }
</mat-menu>
